// DS: WEB 9.1 NFT Details Box
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Info from '@wix/da-ds/pkg/Icons/16x16/Info';
import Edit from '@wix/da-ds/pkg/Icons/24x24/Edit';
import s from './NftDetails.scss';
var NftDetails = function (_a) {
    var deviation = _a.deviation, nft = _a.nft, isOwner = _a.isOwner, showNftEditPopup = _a.showNftEditPopup;
    var t = useTranslation().t;
    var nft_deviation_edit = useFlag('nft_deviation_edit');
    return (React.createElement(Section, { className: s['root'] },
        React.createElement(Heading, { className: s['heading'] },
            t('deviation.nft.heading'),
            React.createElement(SophisticatedTooltip, { size: "large", width: 224, heading: t('deviation.nft.heading.tooltip.title'), description: t('deviation.nft.heading.tooltip.text', {
                    postProcess: 'reactPostprocessor',
                    br: React.createElement("br", null),
                    learnMore: (React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: t('deviation.nft.heading.tooltip.learnMore.url'), className: classnames(s['learn-more'], 'text-link-level-1-brand') }, t('deviation.nft.heading.tooltip.learnMore.label'))),
                }), className: s['heading-icon'] },
                React.createElement(Info, { size: IconSize.SMALLER })),
            nft_deviation_edit && isOwner && (React.createElement(PlainButtonOrLink, { className: s['edit-icon'], onClick: function () { return showNftEditPopup(deviation, nft); } },
                React.createElement(Edit, null)))),
        React.createElement("ul", { className: s['items'] },
            React.createElement("li", { key: "contract", className: s['item'] },
                React.createElement("dl", null,
                    React.createElement("dt", { className: s['item-name'] }, t('deviation.nft.item.contract')),
                    React.createElement("dd", { className: s['contract'] },
                        React.createElement("span", { className: s['contract-prefix'] }, "0x".concat(nft.blockchainIdentifierPrimary.slice(0, -4))),
                        React.createElement("span", { className: s['contract-postfix'] }, nft.blockchainIdentifierPrimary.slice(-4))))),
            React.createElement("li", { key: "blockchain", className: s['item'] },
                React.createElement("dl", null,
                    React.createElement("dt", { className: s['item-name'] }, t('deviation.nft.item.blockchain')),
                    React.createElement("dd", { className: classnames(s['item-value'], s['blockchain']) }, nft.blockchainName.toLowerCase()))),
            nft.blockchainIdentifierSecondary && (React.createElement("li", { key: "token", className: s['item'] },
                React.createElement("dl", null,
                    React.createElement("dt", { className: s['item-name'] }, t('deviation.nft.item.token')),
                    React.createElement("dd", { className: s['item-value'] }, nft.blockchainIdentifierSecondary))))),
        nft.externalLinks.map(function (link) {
            if (link.type === 'marketplace') {
                return (React.createElement(GhostButton, { className: s['cta'], key: "".concat(link.name, "-").concat(link.url), size: "large", variant: "main", target: "_blank", href: link.url }, link.name && link.name !== 'deviation_custom_marketplace_url'
                    ? t('deviation.nft.marketplace.named', link)
                    : t('deviation.nft.marketplace.unnamed')));
            }
            return null;
        }),
        React.createElement("div", { className: s['protect'] }, t('deviation.nft.footer.protect.label', {
            postProcess: 'reactPostprocessor',
            protect: (React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: t('deviation.nft.footer.protect.link.url'), className: s['protect-link'] }, t('deviation.nft.footer.protect.link.label'))),
        }))));
};
NftDetails.displayName = 'NftDetails';
export default NftDetails;
//# sourceMappingURL=NftDetails.js.map